export default __webpack_public_path__ + "static/media/rdstation.8aa71e24.svg";